import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const calendarListByYear = (year, area) => apiActionCreator({
  'endpoint': `/calendar-tems/calendar?year=${year}&area=${area}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_CALENDAR_TEMS,
    ActionTypes.FETCHED_CALENDAR_TEMS,
    [
      ActionTypes.FETCHED_CALENDAR_TEMS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});


export const calendarDetailList = (parameter) => apiActionCreator({
  'endpoint': `/calendar-tems/calendar-detail?${parameter}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_CALENDAR_DETAIL_TEMS,
    ActionTypes.FETCHED_CALENDAR_DETAIL_TEMS,
    [
      ActionTypes.FETCHED_CALENDAR_DETAIL_TEMS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});


export const calendarUpdateDaTe = (date, parameter, area = 'LOGISTICA') => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/calendar-tems/calendar/${date}/${area}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATE_DATE_CALENDAR_TEMS,
        [
          () => {
            dispatch(calendarDetailList(parameter));
            return {
              'type': ActionTypes.UPDATED_DATE_CALENDAR_TEMS,
            };
          },
        ],
        [
          ActionTypes.UPDATED_DATE_CALENDAR_TEMS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
    }),
  );
};
